import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { createUseStyles } from "react-jss";
import { useSelector } from "react-redux";
import { getUser as getUserSelector } from "../../../services/session/selectors";

const useStyles = createUseStyles(theme => ({
  inline: {
    display: "flex",
    "flex-shrink": 0,
    "align-items": "center",
    height: "100%",
    padding: [0, 10],
    transition: "background-color 0.2s ease",
    cursor: "pointer",
    "background-color": props => (props.open ? "#313131" : "#252525"),

    "&:hover": {
      "background-color": "#313131",
    },

    "& svg": {
      "font-size": 18,
      "margin-right": 10,
    },
  },
  dropdown: {
    position: "absolute",
    top: 50,
    right: 15,
    width: 300,
    overflow: "hidden",
    "background-color": "#252525",
    height: props => (props.open ? 200 : 0),
    transition: "height 0.2s ease",
    "border-radius": [0, 0, 8, 8],
    "z-index": 50,
    display: "flex",
    "flex-direction": "column",
  },
  top: {
    "border-top": `5px solid ${theme.colorRed}`,
    width: "100%",
    "flex-grow": 1,

    "& a": {
      color: "white",
      "text-decoration": "none",
      padding: [15, 20],

      "& svg": {
        "margin-right": 8,
      },
    },
  },
  details: {
    width: "100%",
    display: "flex",
    "align-items": "center",
    margin: [15, 0],

    "& svg": {
      "font-size": 70,
      margin: [0, 15],
    },
  },
  name: {
    color: "white",
    "font-size": 20,
    margin: 0,
  },
  email: {
    "font-size": 12,
    color: "#888",
    margin: 0,
  },
  bottom: {
    "background-color": "#313131",

    "& button": {
      color: "white",
      "background-color": theme.colorRed,
      border: "none",
      "border-radius": 3,
      cursor: "pointer",
      padding: [6, 20],
      "font-size": 14,
      margin: [15, 15],
      float: "right",
    },
  },
}));

const User = ({ logout }) => {
  const [open, setOpen] = useState(false);
  const user = useSelector(getUserSelector);
  const classes = useStyles({ open });
  const ref1 = useRef();
  const ref2 = useRef();

  console.log(open);

  useEffect(() => {
    const current1 = ref1.current;
    const current2 = ref2.current;
    const outside = evt => {
      if (
        open &&
        !current1.contains(evt.target) &&
        !current2.contains(evt.target)
      ) {
        console.log("outside");
        setOpen(false);
      }
    };

    window.addEventListener("click", outside);

    return () => window.removeEventListener("click", outside);
  }, [open]);

  return (
    <>
      <div
        className={classes.inline}
        onClick={() => setOpen(o => !o)}
        ref={ref1}
      >
        <FontAwesomeIcon icon={["fal", "user-circle"]} /> {user.name}
      </div>
      <div className={classes.dropdown} ref={ref2}>
        <div className={classes.top}>
          <div className={classes.details}>
            <FontAwesomeIcon icon={["fas", "user-circle"]} />
            <div>
              <p className={classes.name}>{user.name}</p>
              <p className={classes.email}>{user.email}</p>
            </div>
          </div>
          {user.admin && (
            <a
              href="https://manage.theatro360.com/admin/login"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={["fal", "external-link-alt"]} /> Admin
              Dashboard
            </a>
          )}
        </div>
        <div className={classes.bottom}>
          <button onClick={logout}>Log out</button>
        </div>
      </div>
    </>
  );
};

export default User;
